module.exports = __webpack_public_path__ + "static/media/shapes-line.476a93c1.svg";